module.exports = __webpack_public_path__ + "img/bg.cf6f20a7.svg";